/**
 * =====================================================
 * GLADIUS SPARKLAYER CORE
 * =====================================================
 * - Traductions SparkLayer
 * - Synchronisation quantités B2B
 * - Toast amélioré
 * - Boutons de caissage
 * - Corrections SparkLayer
 * =====================================================
 */
(function () {
  console.log("[Gladius SparkFix] loaded");

  var STYLE_ID = "gladius-sparkfix-style";

  var CSS = `
  spark-account th.savings,
  spark-account td.savings,
  spark-cart th.savings,
  spark-cart td.savings,
  spark-product-card th.savings,
  spark-product-card td.savings {
    display: none !important;
  }

  em.text-success {
    display: none !important;
  }
`;

  // "Your account balance is" translation (FR only)
  var EN_RE = /your\s*account\s*balance\s*is\s*:?\s*/i;
  var FR_TXT = "Votre solde de compte est de ";

  function currentLang() {
    try {
      if (window.Shopify && typeof window.Shopify.locale === "string") {
        return window.Shopify.locale.toLowerCase().startsWith("fr") ? "fr" : "en";
      }
    } catch (e) {}

    var htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return (htmlLang === "fr" || htmlLang.startsWith("fr-")) ? "fr" : "en";
  }

  function isFrench() {
    return currentLang() === "fr";
  }

  function injectStyle(root) {
    if (!root) return;

    if (root === document) {
      if (document.getElementById(STYLE_ID)) return;
      if (!document.head) return;

      var styleDoc = document.createElement("style");
      styleDoc.id = STYLE_ID;
      styleDoc.textContent = CSS;
      document.head.appendChild(styleDoc);
      return;
    }

    try {
      if (root.getElementById && root.getElementById(STYLE_ID)) return;
    } catch (e) {}

    if (root.nodeType === 11 && root.appendChild) {
      var style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    }
  }

  function normalize(s) {
    return (s || "")
      .replace(/\u00A0/g, " ")
      .replace(/[’‘]/g, "'")
      .replace(/\s+/g, " ")
      .trim();
  }

  function translateString(s) {
    if (!s) return s;
    if (!EN_RE.test(s)) return s;
    return s.replace(EN_RE, FR_TXT);
  }

  // FR-only: translates "Your account balance is ..."
  function translateBalanceInRoot(root) {
    if (!root || !isFrench()) return;

    // 1) TEXT nodes
    try {
      var startNode = (root === document) ? document.documentElement : root;
      var walker = document.createTreeWalker(startNode, NodeFilter.SHOW_TEXT, null, false);

      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        if (!t) continue;

        if (EN_RE.test(t)) {
          node.nodeValue = translateString(t);
        }
      }
    } catch (e) {}

    // 2) Fallback: element text
    try {
      var scope = (root === document) ? document : root;
      if (!scope.querySelectorAll) return;

      var els = scope.querySelectorAll("p, div, span, li, strong, em, small");
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var txt = normalize(el.textContent);
        if (!txt) continue;

        if (EN_RE.test(txt)) {
          el.textContent = translateString(el.textContent);
        }
      }
    } catch (e2) {}

    // 3) Attributes
    try {
      var scope2 = (root === document) ? document : root;
      if (!scope2.querySelectorAll) return;

      var els2 = scope2.querySelectorAll("[aria-label],[title]");
      for (var j = 0; j < els2.length; j++) {
        var el2 = els2[j];

        var aria = el2.getAttribute("aria-label");
        if (aria && EN_RE.test(aria)) el2.setAttribute("aria-label", translateString(aria));

        var title = el2.getAttribute("title");
        if (title && EN_RE.test(title)) el2.setAttribute("title", translateString(title));
      }
    } catch (e3) {}
  }

  // FR/EN: translates Spark address UI (works across any Shadow root)
  function translateSparkAddressInRoot(root) {
    if (!root) return;

    var lang = currentLang();
    var T = (lang === "fr")
      ? {
          filterPlaceholder: "Filtrer les adresses par recherche...",
          addNew: "Ajouter une nouvelle adresse",
          reset: "Réinitialiser"
        }
      : {
          filterPlaceholder: "Filter the addresses, by searching...",
          addNew: "Add a new address",
          reset: "Reset"
        };

    try {
      var scope = (root === document) ? document : root;
      if (!scope.querySelectorAll) return;

      // Placeholder filtre adresses
      var inputs = scope.querySelectorAll("input.address-search-filter");
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        if (inp && inp.placeholder !== T.filterPlaceholder) {
          inp.placeholder = T.filterPlaceholder;
        }
      }

      // Bouton nouvelle adresse
      var newBtns = scope.querySelectorAll(".address-new");
      for (var j = 0; j < newBtns.length; j++) {
        var nb = newBtns[j];
        if (nb && (nb.textContent || "").trim() !== T.addNew) {
          nb.textContent = T.addNew;
        }
      }

      // Bouton reset
      var resetBtns = scope.querySelectorAll(".address-reset");
      for (var k = 0; k < resetBtns.length; k++) {
        var rb = resetBtns[k];
        if (rb && (rb.textContent || "").trim() !== T.reset) {
          rb.textContent = T.reset;
        }
      }
    } catch (e) {}
  }

  function walkAllRoots(callback) {
    callback(document);

    var seen = new WeakSet();

    function walk(node) {
      if (!node || !node.querySelectorAll) return;

      var all = node.querySelectorAll("*");
      for (var i = 0; i < all.length; i++) {
        var el = all[i];

        if (el.shadowRoot && !seen.has(el.shadowRoot)) {
          seen.add(el.shadowRoot);
          callback(el.shadowRoot);
          walk(el.shadowRoot);
        }
      }
    }

    walk(document);
  }

  function applyFixes() {
    walkAllRoots(function (root) {
      injectStyle(root);
      translateBalanceInRoot(root);      // FR-only
      translateSparkAddressInRoot(root); // FR/EN
    });
  }

  // Burst helper (Spark often rerenders shortly after)
  function burst() {
    applyFixes();
    setTimeout(applyFixes, 120);
    setTimeout(applyFixes, 350);
    setTimeout(applyFixes, 900);
  }

  // Run now + quick retries
  burst();
  setTimeout(burst, 900);
  setTimeout(burst, 1800);

  // Observer for re-renders
  try {
    var t;
    var observer = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(burst, 60);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {
    console.warn("[Gladius SparkFix] observer error", e);
  }

  // SPA nav
  window.addEventListener("hashchange", function () {
    burst();
    setTimeout(burst, 400);
    setTimeout(burst, 1200);
  });

  (function patchHistory() {
    var push = history.pushState;
    var rep = history.replaceState;

    history.pushState = function () {
      var r = push.apply(this, arguments);
      burst();
      return r;
    };

    history.replaceState = function () {
      var r = rep.apply(this, arguments);
      burst();
      return r;
    };

    window.addEventListener("popstate", function () {
      burst();
      setTimeout(burst, 400);
    });
  })();

  // Extra: clicks inside Spark UI often trigger internal rerenders
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest("spark-drawer") || t.closest("spark-cart") || t.closest("spark-account")) {
      burst();
    }
  }, true);
})();

console.log('[Gladius Spark Toast Fix v17] loaded');

(function () {
  const DEBUG = true;

  let gladiusLastQty = null;
  let gladiusLastQtyAt = 0;
  let gladiusLastCartQtyEl = null;
  let gladiusBaseCartQty = 0;
  

  function log(...args) {
    if (DEBUG) console.log('[Gladius Toast]', ...args);
  }

  function getRecentQty() {
    const age = Date.now() - gladiusLastQtyAt;
    if (Number.isFinite(gladiusLastQty) && age < 5000) return gladiusLastQty;
    return null;
  }

  function getToastElements() {
    const toastEl = document.querySelector('spark-toast');
    if (!toastEl || !toastEl.shadowRoot) return null;

    const root = toastEl.shadowRoot;
    const inner = root.querySelector('.spark-toast--inner');
    if (!inner) return null;
    if (
  !inner.classList.contains('spark-toast--inner__success') &&
  !inner.textContent.toLowerCase().includes('added') &&
  !inner.textContent.toLowerCase().includes('ajout')
) {
  return null;
}

    const btn =
  root.querySelector('.spark-toast--inner-order') ||
  root.querySelector('button') ||
  root.querySelector('a');
    return { root, inner, btn };
  }
  (function () {
  let syncTimer = null;
  let isSyncing = false;

  /* =========================================================
   GLADIUS B2B — EN COMMANDE SUR CARTES NOVA
   Client B2B connecté normalement uniquement
========================================================= */

function syncB2BCardBoQty() {

  const boData = window.customerBoData || {};

  document.querySelectorAll('[id^="B2BCardBoQty"]').forEach(el => {

    const sku = String(el.dataset.sku || '')
      .trim()
      .toUpperCase();

    if (!sku) return;

    const qty = parseInt(boData[sku] || 0, 10) || 0;

    const wrap = document.getElementById(
      el.id.replace('BoQty', 'BoWrap')
    );

    el.textContent = String(qty);

    if (wrap) {
      wrap.style.display = qty > 0 ? 'flex' : 'none';
    }
  });
}

window.syncB2BCardBoQty = syncB2BCardBoQty;

  async function syncB2BCardQty() {
  
    syncB2BCardBoQty();
  
    if (isSyncing) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncB2BCardQty, 350);
    return;
  }

  isSyncing = true;

  try {
    if (!window.spark || !window.spark.getCart) return;

    const cart = await Promise.resolve(window.spark.getCart());

    const items =
      Array.isArray(cart) ? cart :
      Array.isArray(cart?.items) ? cart.items :
      Array.isArray(cart?.cartItems) ? cart.cartItems :
      Array.isArray(cart?.lines) ? cart.lines :
      [];

    const bySku = {};

    items.forEach(item => {
      const sku = String(
        item?.sku ||
        item?.variant_sku ||
        item?.settings?.sku ||
        item?.code ||
        ''
      ).trim().toUpperCase();

      const qty = parseInt(
        item?.quantity ||
        item?.qty ||
        item?.count ||
        0,
        10
      ) || 0;

      if (sku) {
        bySku[sku] = (bySku[sku] || 0) + qty;
      }
    });

    document.querySelectorAll('[id*="B2BCardCartQty"], .b2bqo-cartqty').forEach(el => {
      const sku = String(el.dataset.sku || el.getAttribute('data-sku') || '').trim().toUpperCase();
      if (!sku) return;

      const qty = bySku[sku] || 0;
      el.textContent = String(qty);
      el.classList.toggle('is-zero', qty <= 0);
    });

    document.querySelectorAll('[id^="B2BCardBoQty"]').forEach(el => {
      const sku = String(el.dataset.sku || '').trim().toUpperCase();
      if (!sku) return;

      const qty = parseInt(window.customerBoData?.[sku] || 0, 10) || 0;
      const wrap = document.getElementById(el.id.replace('BoQty', 'BoWrap'));

      el.textContent = String(qty);

      if (wrap) {
        wrap.style.display = qty > 0 ? 'flex' : 'none';
      }
    });

  } catch (err) {
    console.warn('[Gladius B2B Sync] erreur', err);
  } finally {
    isSyncing = false;
  }
}
  window.syncB2BCardQty = syncB2BCardQty;

  function queueSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncB2BCardQty, typeof delay === 'number' ? delay : 180);
  }

  // Initial
  queueSync(250);
  setTimeout(syncB2BCardQty, 700);
  setTimeout(syncB2BCardQty, 1400);

  // Seulement sur les vrais boutons d’ajout
  document.addEventListener('click', function (e) {
    const btn = e.target.closest && e.target.closest('button');
    if (!btn) return;

    const txt = (btn.textContent || '').toLowerCase();
    if (!txt.includes('ajouter') && !txt.includes('add')) return;

    setTimeout(syncB2BCardQty, 300);
    setTimeout(syncB2BCardQty, 900);
    setTimeout(syncB2BCardQty, 1600);
setTimeout(syncB2BCardQty, 2600);
  }, true);

  // Recherche : attendre que le DOM soit stabilisé
  document.addEventListener('input', function (e) {
    const target = e.target;
    if (!target) return;

    if (
      target.type === 'search' ||
      target.matches('input[type="search"], input[name="q"], .search__input')
    ) {
      queueSync(400);
      setTimeout(syncB2BCardQty, 900);
    }
  }, true);

  // Observer léger, sans spam
  const obs = new MutationObserver(() => {
    queueSync(250);
  });

  obs.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

  function renderToastBlock(cartQty) {
  const els = getToastElements();
  if (!els) return;

  const { inner, btn } = els;

  if (btn) btn.textContent = 'Voir mon panier';

  const addedQty = getRecentQty();
  if (!Number.isFinite(addedQty)) return;

  const existing = inner.querySelector('.gladius-enhanced');

  // ✅ ne pas écraser une vraie valeur avec "Calcul en cours..."
  if (existing && cartQty == null) {
    const existingText = existing.textContent || '';
    if (existingText.includes('Au panier :')) {
      return;
    }
  }

  if (existing) existing.remove();

  const extra = document.createElement('div');
  extra.className = 'gladius-enhanced';
  extra.style.marginTop = '8px';
  extra.style.padding = '8px 10px';
  extra.style.background = '#eef6ff';
  extra.style.border = '1px solid #b9d8ff';
  extra.style.borderRadius = '8px';
  extra.style.fontSize = '13px';
  extra.style.lineHeight = '1.4';

  const unitLabel = addedQty > 1 ? 'unités' : 'unité';

  let html = `<div><strong>Ajout :</strong> +${addedQty} ${unitLabel}</div>`;

  if (Number.isFinite(cartQty)) {
    html += `<div><strong>Au panier :</strong> ${cartQty} unités</div>`;
  } else {
    html += `<div>Calcul en cours...</div>`;
  }

  extra.innerHTML = html;

  if (btn && btn.parentNode) {
    btn.parentNode.insertBefore(extra, btn);
  } else {
    inner.appendChild(extra);
  }
}

  function safeRenderToastBlock(cartQty) {
    try {
      renderToastBlock(cartQty);
    } catch (err) {
      console.warn('Erreur renderToastBlock', err);
    }
  }

  function updateToastFromSavedQtyElement() {
    const addedQty = getRecentQty();

    let computedQty = null;

    if (Number.isFinite(gladiusBaseCartQty) && Number.isFinite(addedQty)) {
      computedQty = gladiusBaseCartQty + addedQty;
    } else if (Number.isFinite(gladiusBaseCartQty)) {
      computedQty = gladiusBaseCartQty;
    }

    log('base qty panier =', gladiusBaseCartQty);
    log('qty ajoutée =', addedQty);
    log('qty calculée =', computedQty);

    safeRenderToastBlock(computedQty);
  }

  function getSparkHostFromEvent(e) {
    const path = e.composedPath ? e.composedPath() : [];

    const hostFromPath = path.find(
      (el) =>
        el instanceof HTMLElement &&
        el.tagName &&
        (
          el.tagName.toLowerCase() === 'spark-product-card' ||
          el.tagName.toLowerCase() === 'spark-pdp'
        )
    );

    if (hostFromPath) return hostFromPath;

    const target = e.target instanceof HTMLElement ? e.target : null;
    if (!target) return null;

    return (
      target.closest('spark-product-card') ||
      target.closest('spark-pdp') ||
      null
    );
  }

  function getButtonFromEvent(e) {
    const path = e.composedPath ? e.composedPath() : [];

    const btnFromPath = path.find(
      (el) => el instanceof HTMLElement && el.tagName === 'BUTTON'
    );
    if (btnFromPath) return btnFromPath;

    const target = e.target instanceof HTMLElement ? e.target : null;
    if (!target) return null;

    return target.closest('button');
  }

  function getQtyFromSparkHost(sparkHost, fallbackContainer) {
  let qty = null;

  // 🔥 1. PRIORITÉ PDP (plus stable)
  if (sparkHost && sparkHost.tagName.toLowerCase() === 'spark-pdp') {
    const input =
      sparkHost.shadowRoot?.querySelector('input.input-quantity') ||
      sparkHost.shadowRoot?.querySelector('input[type="number"]');

    if (input) {
      const val = parseInt(input.value, 10);
      if (Number.isFinite(val)) {
        return val;
      }
    }
  }

  // 🔥 2. CAS spark-product-card (liste de prix)
  if (sparkHost && sparkHost.shadowRoot) {
    const input =
      sparkHost.shadowRoot.querySelector('input.input-quantity') ||
      sparkHost.shadowRoot.querySelector('input[type="number"]');

    if (input) {
      const val = parseInt(input.value, 10);
      if (Number.isFinite(val)) {
        return val;
      }
    }
  }

  // 🔥 3. FALLBACK DOM visible (très important PDP)
  if (fallbackContainer) {
    const input =
      fallbackContainer.querySelector('input[name="quantity"]') ||
      fallbackContainer.querySelector('input[type="number"]');

    if (input) {
      const val = parseInt(input.value, 10);
      if (Number.isFinite(val)) {
        return val;
      }
    }
  }

  return 0; // 🔥 fallback sécuritaire
}

  function getParentId(sparkHost, btn) {
    let parentId = null;

    if (sparkHost) {
      parentId =
        sparkHost.getAttribute('parent-id') ||
        sparkHost.dataset?.parentId ||
        null;
    }

    if (!parentId && btn) {
      const td = btn.closest?.('.b2bqo-td-commander');
      const row = td?.closest?.('.b2bqo-row');
      const sparkInRow = row?.querySelector?.('spark-product-card[parent-id], spark-pdp[parent-id]');

      if (sparkInRow) {
        parentId =
          sparkInRow.getAttribute('parent-id') ||
          sparkInRow.dataset?.parentId ||
          null;
      }
    }

    return parentId;
  }

  function getCartQtyEl(parentId, container, sparkHost) {
  let cartQtyEl = null;

  // 1) Liste de prix
  if (parentId) {
    cartQtyEl = document.querySelector(
      '.b2bqo-cartqty[data-product-id="' + String(parentId) + '"]'
    );
  }

  // 2) PDP
  if (!cartQtyEl && parentId) {
    cartQtyEl = document.querySelector('#B2BCartQty-' + String(parentId));
  }

  // 3) Chercher localement dans le container visible
  if (!cartQtyEl && container) {
    cartQtyEl =
      container.querySelector('.b2b-card-meta__value[data-sku]') ||
      container.querySelector('.b2b-card-meta__value[data-variant-id]') ||
      container.querySelector('[id^="B2BCardCartQty-"]');
  }

  // 4) Chercher dans le wrapper du spark host
  if (!cartQtyEl && sparkHost) {
    const wrapper =
      sparkHost.closest('.card-wrapper, .product-card, .grid__item, [class*="card"]') ||
      null;

    if (wrapper) {
      cartQtyEl =
        wrapper.querySelector('.b2b-card-meta__value[data-sku]') ||
        wrapper.querySelector('.b2b-card-meta__value[data-variant-id]') ||
        wrapper.querySelector('[id^="B2BCardCartQty-"]');
    }
  }

  // 5) Fallback par variant-id
  if (!cartQtyEl && sparkHost) {
    const variantId =
      sparkHost.getAttribute('data-variant-id') ||
      sparkHost.dataset?.variantId ||
      null;

    if (variantId) {
      cartQtyEl = document.querySelector(
        '.b2b-card-meta__value[data-variant-id="' + String(variantId) + '"]'
      );
    }
  }

  // 6) Fallback par SKU global
  if (!cartQtyEl && sparkHost) {
    const sku =
      sparkHost.getAttribute('data-sku') ||
      sparkHost.dataset?.sku ||
      null;

    if (sku) {
      cartQtyEl = document.querySelector(
        '.b2b-card-meta__value[data-sku="' + String(sku).trim().toUpperCase() + '"]'
      );
    }
  }

  return cartQtyEl || null;
}

  function getBaseCartQty(cartQtyEl) {
    if (!cartQtyEl) return 0;

    const txt = (cartQtyEl.textContent || '').trim();
    const val = parseInt(txt, 10);

    return Number.isFinite(val) ? val : 0;
  }

  function handleAddClick(e) {
  const btn = getButtonFromEvent(e);
  if (!btn) return;

  const btnText = (btn.textContent || '').trim();
  const sparkHost = getSparkHostFromEvent(e);

  if (!sparkHost && !btnText.includes('Ajouter') && !btnText.includes('Add')) {
    return;
  }

  const container =
    btn.closest?.('.card-wrapper, .product-card, .grid__item') ||
    btn.closest?.('[class*="card"]') ||
    btn.closest?.('.product__info-wrapper') ||
    null;

  const qty = getQtyFromSparkHost(sparkHost, container);
  const parentId = getParentId(sparkHost, btn);
  const cartQtyEl = getCartQtyEl(parentId, container, sparkHost);
  const baseCartQty = getBaseCartQty(cartQtyEl);

  gladiusBaseCartQty = baseCartQty;
  gladiusLastQty = qty;
  gladiusLastQtyAt = Date.now();
  gladiusLastCartQtyEl = cartQtyEl || null;

  log('parentId capturé =', parentId);
  log('base qty panier capturée =', gladiusBaseCartQty);
  log('qty ajoutée =', gladiusLastQty);
  log('cartQtyEl capturé =', gladiusLastCartQtyEl);

  // affichage immédiat optimiste
  updateToastFromSavedQtyElement();

  // attendre que Spark refresh le panier
  setTimeout(updateToastFromSavedQtyElement, 500);
  setTimeout(updateToastFromSavedQtyElement, 1200);
}

  document.addEventListener('click', handleAddClick, true);

function runToastPatch() {
  const addedQty = getRecentQty();
  if (!Number.isFinite(addedQty)) return;

  // ✅ ne pas pousser "Calcul en cours..." si on a déjà mieux
  safeRenderToastBlock(gladiusBaseCartQty + addedQty);
  setTimeout(() => safeRenderToastBlock(gladiusBaseCartQty + addedQty), 80);
  setTimeout(() => safeRenderToastBlock(gladiusBaseCartQty + addedQty), 180);
  setTimeout(() => safeRenderToastBlock(gladiusBaseCartQty + addedQty), 350);
}

const observer = new MutationObserver(() => {
  runToastPatch();
});

observer.observe(document.documentElement, {
  childList: true,
  subtree: true
});
})();
(function () {
  if (document.body.classList.contains('b2b-customer')) return;

  const el = document.getElementById('CartSkuCount');
  if (!el) return;

  let lastValue = null;
  let pending = null;

  function setBadge(value) {
    el.textContent = String(value);
    el.style.display = value > 0 ? 'inline-block' : 'none';
  }

  async function updateSkuCount() {
    if (pending) return pending;

    pending = fetch('/cart.js', { credentials: 'same-origin' })
      .then((res) => res.json())
      .then((cart) => {
        const items = cart.items;
        let skuCount = 0;

        if (Array.isArray(items)) {
          const uniqueSkus = new Set(
            items
              .map((item) => (item.sku || item.key || item.variant_id || '').toString().trim())
              .filter(Boolean)
          );

          skuCount = uniqueSkus.size > 0 ? uniqueSkus.size : items.length;
        } else if (typeof items === 'object' && items !== null) {
          skuCount = Object.keys(items).length;
        }

        if (skuCount !== lastValue) {
          lastValue = skuCount;
          setBadge(skuCount);
        }
      })
      .catch((err) => {
        console.warn('[Gladius SKU Count] erreur', err);
      })
      .finally(() => {
        pending = null;
      });

    return pending;
  }

  function queueUpdate(delay) {
    setTimeout(updateSkuCount, delay || 0);
  }

  updateSkuCount();

  document.addEventListener('cart:updated', () => queueUpdate(150));
  document.addEventListener('cart:refresh', () => queueUpdate(150));

  document.addEventListener('click', function () {
    queueUpdate(250);
    queueUpdate(800);
    queueUpdate(1400);
  }, true);
})();


// ===== Gladius - boutons custom caissage seulement =====
(function () {
  const KEY = 'gladiusCaseButtonsSearchFixV1';
  if (window[KEY]) return;
  window[KEY] = true;

  function getClickedButton(event) {
    const path = event.composedPath ? event.composedPath() : [];
    for (const node of path) {
      if (
        node instanceof HTMLElement &&
        (node.matches?.('[data-action="minus-case"]') ||
         node.matches?.('[data-action="plus-case"]'))
      ) {
        return node;
      }
    }

    const target = event.target instanceof HTMLElement ? event.target : null;
    return target?.closest?.('[data-action="minus-case"], [data-action="plus-case"]') || null;
  }

  function getCardRoot(btn) {
    return (
      btn.closest('.nova-card-product') ||
      btn.closest('.product-card-wrapper') ||
      btn.closest('.card-wrapper') ||
      btn.closest('.grid__item') ||
      btn.closest('[class*="card"]') ||
      null
    );
  }

  function getSparkHost(cardRoot) {
    if (!cardRoot) return null;
    return cardRoot.querySelector('spark-product-card, spark-pdp');
  }

  function getSparkInput(host) {
    if (!host?.shadowRoot) return null;
    return (
      host.shadowRoot.querySelector('input.input-quantity') ||
      host.shadowRoot.querySelector('input[type="number"]') ||
      null
    );
  }

  function getCaseQty(host) {
    return parseInt(
      host?.getAttribute('data-b2b-case-qty') ||
      host?.dataset?.b2bCaseQty ||
      '1',
      10
    ) || 1;
  }

  function setQty(input, qty) {
    const safeQty = Math.max(0, parseInt(qty, 10) || 0);
    input.value = String(safeQty);
    input.setAttribute('value', String(safeQty));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncHiddenQty(cardRoot, qty) {
    if (!cardRoot) return;

    cardRoot.querySelectorAll('input.b2b-card-qty-input').forEach((el) => {
      el.value = String(Math.max(0, parseInt(qty, 10) || 0));
    });
  }

  document.addEventListener('click', function (e) {
    
    const btn = getClickedButton(e);
    if (!btn) return;

    const cardRoot = getCardRoot(btn);
    const sparkHost = getSparkHost(cardRoot);
    const input = getSparkInput(sparkHost);

    if (!sparkHost || !input) {
      console.warn('[Gladius case buttons] spark host ou input introuvable');
      return;
    }

    const caseQty = getCaseQty(sparkHost);
    const current = parseInt(input.value || '0', 10) || 0;

    let nextQty = current;

    if (btn.matches('[data-action="plus-case"]')) {
  if (current <= 1) {
    nextQty = caseQty;
  } else {
    nextQty = current + caseQty;
  }
} else if (btn.matches('[data-action="minus-case"]')) {
  nextQty = current <= caseQty ? 0 : current - caseQty;
}

    /*e.preventDefault();*/
    /*e.stopPropagation();*/
    e.stopImmediatePropagation();

    setQty(input, nextQty);
    syncHiddenQty(cardRoot, nextQty);

    console.log('[Gladius case buttons]', {
      action: btn.getAttribute('data-action'),
      current,
      caseQty,
      nextQty,
      sku: sparkHost.getAttribute('data-sku')
    });
  }, true);

  document.addEventListener('gladius:refresh', function () {
  console.log('[Gladius] refresh triggered');

  try {
    if (typeof burst === 'function') burst();
  } catch (e) {}

  try {
    if (typeof window.syncB2BCardQty === 'function') {
      window.syncB2BCardQty();
    }
  } catch (e) {}
});
})();

/**
 * Gladius - SparkLayer Account Members translations (Lit-safe)
 * - Applies translations inside spark-account shadowRoot
 * - Re-applies after each Lit render (patch requestUpdate)
 * - Christian Audette 2026-02-18
 */
(function () {
  console.log("Gladius Spark Account Members i18n (CSS overlay) loaded");

  function isFR() {
    try {
      return (window.Shopify?.locale || "").toLowerCase().startsWith("fr");
    } catch (e) {}
    const lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return lang.startsWith("fr");
  }

  function findSparkAccount() {
    const seen = new Set();
    const queue = [document];
    while (queue.length) {
      const root = queue.shift();
      if (!root || seen.has(root)) continue;
      seen.add(root);

      const el = root.querySelector?.("spark-account");
      if (el) return el;

      root.querySelectorAll?.("*").forEach(n => {
        if (n.shadowRoot) queue.push(n.shadowRoot);
      });
    }
    return null;
  }

  function installOverlay() {
    if (!isFR()) return;

    const acc = findSparkAccount();
    if (!acc || !acc.shadowRoot) return;

    acc.setAttribute("data-gladius-locale", "fr");

    const root = acc.shadowRoot;
    const wrap = root.querySelector(".radio-wrap");
    if (wrap && !root.querySelector(".gladius-user-role-title")) {
      const title = document.createElement("div");
      title.className = "gladius-user-role-title";
      title.textContent = "Rôle utilisateur";
      wrap.parentElement?.insertBefore(title, wrap);
    }

    if (!root.getElementById("gladius-role-i18n-style")) {
      const style = document.createElement("style");
      style.id = "gladius-role-i18n-style";
      style.textContent = `
:host([data-gladius-locale="fr"]) spark-header[level="4"] { display: none !important; }

:host([data-gladius-locale="fr"]) .gladius-user-role-title{
  font-weight: 600;
  margin: 0 0 10px 0;
}

:host([data-gladius-locale="fr"]) p.role-name,
:host([data-gladius-locale="fr"]) p.role-description{
  position: relative;
  color: transparent !important;
}

:host([data-gladius-locale="fr"]) p.role-name::after,
:host([data-gladius-locale="fr"]) p.role-description::after{
  position: absolute;
  left: 0;
  top: 0;
  color: rgba(0,0,0,0.88);
  white-space: pre-line;
}

:host([data-gladius-locale="fr"]) label[for="role-main"] p.role-name::after{
  content: "Standard";
}
:host([data-gladius-locale="fr"]) label[for="role-main"] p.role-description::after{
  content: "Permet de passer des commandes et de consulter toute l’activité du compte d’entreprise partagé.";
}

:host([data-gladius-locale="fr"]) label[for="role-limited-customer"] p.role-name::after{
  content: "Limité";
}
:host([data-gladius-locale="fr"]) label[for="role-limited-customer"] p.role-description::after{
  content: "L’utilisateur peut ajouter des articles à une commande, mais ne peut pas la finaliser. Les commandes seront envoyées au propriétaire du compte pour approbation.";
}
      `;
      root.appendChild(style);
    }
  }

  function boot() {
    let n = 0;
    const iv = setInterval(() => {
      installOverlay();
      n++;
      if (n >= 30) clearInterval(iv);
    }, 200);

    const mo = new MutationObserver(() => {
      clearTimeout(window.__gladiusRoleOverlayT);
      window.__gladiusRoleOverlayT = setTimeout(installOverlay, 50);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();


(function () {
  const key = 'gladiusHideStockGlobal';
  if (window[key]) return;
  window[key] = true;

  function hideStock(root) {
    if (!root || !root.querySelectorAll) return;

    try {
      root.querySelectorAll('.stock-status, .stock-status.in-stock, p.stock-status').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.dataset.gladiusHidden = '1';
      });
    } catch (e) {}

    try {
      root.querySelectorAll('*').forEach(function (node) {
        if (node.shadowRoot) {
          hideStock(node.shadowRoot);
        }
      });
    } catch (e) {}
  }

  function run() {
    hideStock(document);
  }

  run();
  setTimeout(run, 300);
  setTimeout(run, 800);
  setTimeout(run, 1500);

  const obs = new MutationObserver(function () {
    run();
  });

  obs.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function () {
  if (!document.body.classList.contains('b2b-customer')) return;

  const badge = document.getElementById('B2BCartBadge');
  if (!badge) return;

  let sparkReady = false;
  let stopped = false;
  let intervalId = null;
  let queued = false;

  function setBadge(count) {
    const value = Number(count) || 0;
    badge.textContent = String(value);
    badge.style.display = value > 0 ? 'inline-flex' : 'none';
  }

  function stopBadgeSync(reason) {
    stopped = true;
    sparkReady = false;
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    console.warn('[B2B badge stopped]', reason);
  }

  async function updateFromSpark() {
    if (stopped) return;
    if (!window.spark || typeof window.spark.getCart !== 'function') return;

    try {
      const sparkCart = await window.spark.getCart();
      const items = Array.isArray(sparkCart?.items) ? sparkCart.items : [];

      const byKey = {};
      items.forEach((item) => {
        const key = String(
          item?.sku ||
          item?.settings?.sku ||
          item?.product_sku ||
          item?.variant_sku ||
          item?.itemKey ||
          item?.product_id ||
          item?.variant_id ||
          ''
        ).trim().toUpperCase();

        const qty = parseInt(item?.quantity || item?.qty || item?.count || 0, 10) || 0;

        if (key) byKey[key] = (byKey[key] || 0) + qty;
      });

      const count = Object.keys(byKey).length || items.length || 0;
      setBadge(count);
    } catch (e) {
      const msg = String(e?.message || e || '');

      if (
        msg.includes('401') ||
        msg.toLowerCase().includes('unauthorized') ||
        msg.toLowerCase().includes('error fetching cart')
      ) {
        stopBadgeSync('Spark unauthorized');
        return;
      }

      console.log('[B2B badge error]', e);
    }
  }

  function queueUpdate(delay) {
    if (stopped) return;
    setTimeout(() => {
      if (!stopped && sparkReady) updateFromSpark();
    }, delay);
  }

  function waitForSpark() {
    let tries = 0;

    const timer = setInterval(() => {
      tries++;

      if (window.spark && typeof window.spark.getCart === 'function') {
        clearInterval(timer);
        sparkReady = true;

        updateFromSpark();
        queueUpdate(500);
        queueUpdate(1200);
        queueUpdate(2500);

        if (!intervalId) {
          intervalId = setInterval(() => {
            if (!stopped) updateFromSpark();
          }, 15000);
        }
      }

      if (tries > 150) {
        clearInterval(timer);
      }
    }, 200);
  }

  document.addEventListener('DOMContentLoaded', waitForSpark);
  window.addEventListener('load', waitForSpark);

  document.addEventListener('click', function () {
    if (!sparkReady || stopped) return;
    queueUpdate(400);
    queueUpdate(1200);
    queueUpdate(2200);
  }, true);
})();


(function () {
  const KEY = '__gladiusB2BWakeFix';
  if (window[KEY]) return;
  window[KEY] = true;

  function wakeB2B() {
    console.log('[Gladius] Wake B2B');

    // 🔁 Force SparkLayer à se réveiller
    try {
      if (window.spark?.getCart) {
        window.spark.getCart();
      }
    } catch (e) {}

    // 🔁 Relance tous tes scripts custom (IMPORTANT dans ton setup)
    document.dispatchEvent(new CustomEvent('gladius:refresh'));

    // 🔁 Petit burst (Spark est async)
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('gladius:refresh'));
    }, 500);

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('gladius:refresh'));
    }, 1200);
  }

  // 🔥 Quand on revient sur la page après inactivité
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      wakeB2B();
    }
  });

  // 🔥 Quand la souris revient / interaction
  window.addEventListener('focus', wakeB2B);

})();


(function () {

  function isB2B() {
    return document.body && document.body.classList.contains("b2b-customer");
  }

  function normalize(s) {
    return (s || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function hideSoldeInRoot(root) {
    if (!root || !root.querySelectorAll) return;

    const nodes = root.querySelectorAll("*");

    nodes.forEach((el) => {
      const t = normalize(el.textContent);
      if (t === "en solde" || t === "solde" || t === "sale") {
        el.style.setProperty("display", "none", "important");
      }
    });
  }

  function scanSparkProductCards() {
    if (!isB2B()) return;

    document.querySelectorAll("spark-product-card").forEach((host) => {
      if (host.shadowRoot) {
        hideSoldeInRoot(host.shadowRoot);
      }
      hideSoldeInRoot(host);
    });
  }

  function boot() {
    scanSparkProductCards();

    const mo = new MutationObserver(() => {
      clearTimeout(window.__gladiusHideSoldeT);
      window.__gladiusHideSoldeT = setTimeout(scanSparkProductCards, 50);
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

})();


            (function () {
              function applySparkTieredPricingColor() {
                document.querySelectorAll('spark-product-card').forEach((host) => {
                  const root = host.shadowRoot;
                  if (!root) return;

                  root.querySelectorAll('span.pricing').forEach((el) => {
                    el.style.setProperty('color', '#000', 'important');
                    el.style.setProperty('opacity', '1', 'important');
                  });
                });
              }

              // 1) au chargement initial
              applySparkTieredPricingColor();

              // 2) SparkLayer injecte/refresh souvent après coup → on observe le DOM
              const obs = new MutationObserver(() => applySparkTieredPricingColor());
              obs.observe(document.documentElement, { childList: true, subtree: true });

              // 3) optionnel: stop après 10 secondes (évite d’observer pour toujours)
              setTimeout(() => obs.disconnect(), 10000);
          })();


// =========================================================
// GLADIUS - WAKE SPARK CART WITHOUT BLOCKING CLICK
// Ne bloque aucun clic, ne casse pas les qty produit
// =========================================================

(function () {
  function wakeSparkCart() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      if (window.spark && typeof window.spark.getCart === 'function') {
        window.spark.getCart().catch(function(){});
      }

      if (typeof window.syncB2BCardQty === 'function') {
        setTimeout(window.syncB2BCardQty, 250);
        setTimeout(window.syncB2BCardQty, 800);
      }
    } catch (e) {}
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      setTimeout(wakeSparkCart, 250);
      setTimeout(wakeSparkCart, 900);
    }
  });

  window.addEventListener('pageshow', function () {
    setTimeout(wakeSparkCart, 250);
    setTimeout(wakeSparkCart, 900);
  });

  document.addEventListener('pointermove', function () {
    wakeSparkCart();
  }, { once: true, passive: true });

  document.addEventListener('touchstart', function () {
    wakeSparkCart();
  }, { once: true, passive: true });
})();

// =====================================================
// GLADIUS - B2B Shopify account page fallback
// Si un B2B tombe dans /account Shopify, on le renvoie vers Spark
// =====================================================
(function () {
  const KEY = "__gladiusB2BAccountFallbackV2";
  if (window[KEY]) return;
  window[KEY] = true;

  function hasSparkAuth() {
    return !!(window.sparkOptions && window.sparkOptions.auth && window.sparkOptions.auth.token);
  }

  function isShopifyHostedAccount() {
    return (
      window.location.hostname.includes("shopify.com") &&
      window.location.pathname.includes("/account")
    );
  }

  function run() {
    if (!hasSparkAuth()) return;
    if (!isShopifyHostedAccount()) return;

    window.location.replace("https://gladius.ca/index");
  }

  run();
})();
(function () {
  const KEY = "__gladiusAccountWakeBeforeNav";
  if (window[KEY]) return;
  window[KEY] = true;

  function hasSparkAuth() {
    return !!(window.sparkOptions && window.sparkOptions.auth && window.sparkOptions.auth.token);
  }

  function isB2BAccountLink(link) {
    return (
      link &&
      document.body &&
      document.body.classList.contains("b2b-customer") &&
      hasSparkAuth()
    );
  }

  function wakeSparkLayer() {
    try {
      if (window.spark?.getCart) window.spark.getCart();
    } catch (e) {}

    document.dispatchEvent(new CustomEvent("gladius:refresh"));
  }

  document.addEventListener("pointerdown", function (e) {
    const link = e.target.closest?.("[data-gladius-account-link]");
    if (!isB2BAccountLink(link)) return;

    wakeSparkLayer();
  }, true);
})();

